/* eslint-disable max-len */
export const IconPec1 = () => {
    return (
        <svg
            width="85"
            height="72"
            viewBox="0 0 85 72"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="step-icon"
        >
            <path
                d="M42.1467 25.1401C48.3654 25.1401 53.4067 19.7359 53.4067 13.0698C53.4067 6.40375 48.3654 1 42.1467 1C35.928 1 30.8867 6.40375 30.8867 13.0698C30.8867 19.7359 35.928 25.1401 42.1467 25.1401Z"
                fill="white"
                stroke="#2B2B2B"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M64.9378 63.3198L68.9378 60.7402C73.2078 57.6802 75.6878 53.3502 73.1578 47.6602C71.3218 43.5491 69.1511 39.5955 66.6678 35.8398C63.7778 31.5698 60.0678 29.5898 55.3478 29.5898H28.9778C24.2678 29.5898 20.5478 31.5898 17.6678 35.8398C15.1845 39.5955 13.0138 43.5491 11.1778 47.6602C8.64779 53.3502 11.1278 57.6602 15.3978 60.7402L19.3978 63.3198"
                fill="white"
            />
            <path
                d="M64.9378 63.3198L68.9378 60.7402C73.2078 57.6802 75.6878 53.3502 73.1578 47.6602C71.3218 43.5491 69.1511 39.5955 66.6678 35.8398C63.7778 31.5698 60.0678 29.5898 55.3478 29.5898H28.9778C24.2678 29.5898 20.5478 31.5898 17.6678 35.8398C15.1845 39.5955 13.0138 43.5491 11.1778 47.6602C8.64779 53.3502 11.1278 57.6602 15.3978 60.7402L19.3978 63.3198"
                stroke="#1D1D1D"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M62.5189 70.0401H21.7489C21.2731 70.041 20.8148 69.8608 20.4673 69.5357C20.1199 69.2105 19.9095 68.7649 19.8789 68.2901L18.4289 45.2901C18.385 44.6491 18.4735 44.0062 18.689 43.4009C18.9044 42.7956 19.2421 42.241 19.6812 41.772C20.1202 41.3029 20.6511 40.9293 21.2408 40.6743C21.8306 40.4194 22.4665 40.2885 23.1089 40.2901H61.1589C61.801 40.29 62.4362 40.4218 63.0252 40.6773C63.6142 40.9327 64.1445 41.3062 64.5833 41.7749C65.022 42.2437 65.3598 42.7977 65.5758 43.4024C65.7918 44.007 65.8814 44.6494 65.8389 45.2901L64.3889 68.2901C64.3561 68.7641 64.145 69.2081 63.798 69.5327C63.4511 69.8574 62.9941 70.0387 62.5189 70.0401Z"
                fill="#FFE22E"
                stroke="#1D1D1D"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M1 65.4702H19.7"
                stroke="#1D1D1D"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M83.2703 65.4702H64.5703"
                stroke="#1D1D1D"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const IconPec2 = () => {
    return (
        <svg
            width="84"
            height="72"
            viewBox="0 0 84 72"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="step-icon"
        >
            <path
                d="M8.64844 63.1299V23C8.65107 22.3882 8.89524 21.8018 9.32788 21.3691C9.76052 20.9365 10.3466 20.6926 10.9584 20.6899H69.5284C70.1393 20.6926 70.7243 20.9372 71.1553 21.3701C71.5864 21.803 71.8284 22.3891 71.8284 23V62.4897"
                fill="white"
            />
            <path
                d="M8.64844 63.1299V23C8.65107 22.3882 8.89524 21.8018 9.32788 21.3691C9.76052 20.9365 10.3466 20.6926 10.9584 20.6899H69.5284C70.1393 20.6926 70.7243 20.9372 71.1553 21.3701C71.5864 21.803 71.8284 22.3891 71.8284 23V62.4897"
                stroke="#1D1D1D"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M76.41 70.4897H4.08002C3.67602 70.4911 3.27572 70.413 2.9021 70.2593C2.52848 70.1056 2.18885 69.8794 1.90271 69.5942C1.61657 69.309 1.38953 68.9703 1.23462 68.5972C1.07971 68.224 0.999998 67.8239 1 67.4199V63.1299H79.49V67.4199C79.49 67.8239 79.4103 68.224 79.2554 68.5972C79.1005 68.9703 78.8734 69.309 78.5873 69.5942C78.3011 69.8794 77.9615 70.1056 77.5879 70.2593C77.2143 70.413 76.814 70.4911 76.41 70.4897Z"
                fill="white"
                stroke="#1D1D1D"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M28.6583 43.21C31.7897 43.21 34.3283 40.6715 34.3283 37.54C34.3283 34.4086 31.7897 31.8696 28.6583 31.8696C25.5268 31.8696 22.9883 34.4086 22.9883 37.54C22.9883 40.6715 25.5268 43.21 28.6583 43.21Z"
                fill="#FFE22E"
                stroke="#1D1D1D"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M40.8674 56.6899C40.8674 50.7499 35.4074 45.9199 28.6974 45.9199C21.9874 45.9199 16.5273 50.7499 16.5273 56.6899H40.8674Z"
                fill="#FFE22E"
                stroke="#1D1D1D"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M65.7379 1.70972C61.1508 0.528044 56.3073 0.827737 51.9008 2.56568C47.4942 4.30362 43.7503 7.3907 41.2047 11.3855C38.6591 15.3803 37.4423 20.0776 37.7285 24.8059C38.0147 29.5342 39.7891 34.0511 42.7979 37.7097L41.4279 43.9294L47.6679 42.1194C50.3858 43.9342 53.4671 45.1344 56.6965 45.6355C59.926 46.1366 63.2259 45.9267 66.366 45.0208C69.506 44.1148 72.4106 42.5347 74.8768 40.3904C77.3431 38.2461 79.3117 35.5894 80.6452 32.6057C81.9787 29.6221 82.6451 26.3833 82.5977 23.1155C82.5504 19.8477 81.7904 16.6296 80.371 13.6858C78.9515 10.742 76.9068 8.14347 74.3794 6.07154C71.852 3.9996 68.9029 2.50423 65.7379 1.6897V1.70972Z"
                fill="white"
                stroke="#1D1D1D"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M47.9883 31.2598H72.3183"
                stroke="#1D1D1D"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M47.9883 23.4297H72.3183"
                stroke="#1D1D1D"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M47.9883 15.3198H72.3183"
                stroke="#1D1D1D"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
export const IconPec3 = () => {
    return (
        <svg
            width="68"
            height="70"
            viewBox="0 0 68 70"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="step-icon"
        >
            <path d="M53.097 29.7998H45.957V38.1899H53.097V29.7998Z" fill="white" />
            <path
                d="M1 25.5897L4.89001 44.3798C5.20422 45.6266 5.92589 46.7325 6.94043 47.5224C7.95497 48.3122 9.20428 48.7407 10.4901 48.7396H26.08L29.92 65.5399C30.1602 66.6642 30.8357 67.6476 31.7988 68.2753C32.762 68.903 33.9345 69.1237 35.0601 68.8895C35.618 68.773 36.1475 68.5476 36.6181 68.226C37.0887 67.9043 37.4912 67.4931 37.8024 67.0155C38.1137 66.538 38.3276 66.0037 38.4318 65.4433C38.5361 64.8828 38.5287 64.3074 38.41 63.7499L33.8 42.9496L33.39 38.6098C34.5411 38.6098 35.645 38.1527 36.4589 37.3388C37.2728 36.5249 37.73 35.421 37.73 34.2699C37.73 33.1189 37.2728 32.015 36.4589 31.2011C35.645 30.3872 34.5411 29.9296 33.39 29.9296H22.64L18.04 21.87C17.5006 20.9728 16.7752 20.2012 15.9128 19.6078C15.0503 19.0144 14.0708 18.6127 13.04 18.4296C12.0796 18.2511 11.0897 18.3171 10.1613 18.621C9.23291 18.9249 8.39576 19.457 7.72675 20.1688C7.05773 20.8807 6.57831 21.7493 6.33252 22.6947C6.08672 23.6402 6.08239 24.6324 6.32001 25.58L1 25.5897Z"
                fill="white"
            />
            <path
                d="M14.0087 12.5801C17.2065 12.5801 19.7988 9.98777 19.7988 6.79004C19.7988 3.59231 17.2065 1 14.0087 1C10.811 1 8.21875 3.59231 8.21875 6.79004C8.21875 9.98777 10.811 12.5801 14.0087 12.5801Z"
                fill="white"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M20.3697 38.6098H33.3697C34.5207 38.6098 35.6245 38.1527 36.4384 37.3388C37.2524 36.5249 37.7096 35.421 37.7096 34.2699C37.7096 33.1189 37.2524 32.015 36.4384 31.2011C35.6245 30.3872 34.5207 29.9296 33.3697 29.9296H22.6396L18.0396 21.87C17.5002 20.9728 16.7748 20.2012 15.9124 19.6078C15.0499 19.0144 14.0704 18.6127 13.0396 18.4296C12.0792 18.2511 11.0893 18.3171 10.1609 18.621C9.23252 18.9249 8.39537 19.457 7.72635 20.1688C7.05733 20.8807 6.57792 21.7493 6.33212 22.6947C6.08633 23.6402 6.08199 24.6324 6.31961 25.58"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M1 25.5898L4.89001 44.3799C5.20422 45.6267 5.92589 46.7326 6.94043 47.5225C7.95497 48.3124 9.20428 48.7408 10.4901 48.7397H26.08L29.92 65.54C30.1602 66.6643 30.8357 67.6477 31.7988 68.2754C32.762 68.9031 33.9345 69.1238 35.0601 68.8896C35.618 68.7731 36.1475 68.5477 36.6181 68.2261C37.0887 67.9044 37.4912 67.4932 37.8024 67.0156C38.1137 66.5381 38.3276 66.0038 38.4318 65.4434C38.5361 64.8829 38.5287 64.3075 38.41 63.75L33.8 42.9497"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M34.2578 38.6099H66.5579V68.98"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.17969 68.9897H21.7397"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M15.457 48.73V68"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M45.9375 38.6099V30.1201"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M52.9766 38.6099V30.1201"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M59.6978 29.6597L66.5579 4.23975H42.8679L36.0078 29.6597H59.6978Z"
                fill="#FFE22E"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const IconPec4 = () => {
    return (
        <svg
            width="64"
            height="72"
            viewBox="0 0 64 72"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="step-icon"
        >
            <path
                d="M41.5195 64.7812C41.5195 64.7812 43.1795 68.041 43.5195 68.521C44.8095 70.391 47.4395 70.7513 49.9895 70.1113C54.1195 69.1113 59.6995 66.631 61.9895 62.291C63.3295 59.801 59.7896 56.4912 59.7896 56.4912"
                fill="#FFE22E"
            />
            <path
                d="M41.5195 64.7812C41.5195 64.7812 43.1795 68.041 43.5195 68.521C44.8095 70.391 47.4395 70.7513 49.9895 70.1113C54.1195 69.1113 59.6995 66.631 61.9895 62.291C63.3295 59.801 59.7896 56.4912 59.7896 56.4912"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M47.67 59.2814H2.67004C2.45728 59.2881 2.24525 59.2527 2.04614 59.1774C1.84704 59.1021 1.66474 58.9883 1.50964 58.8424C1.35455 58.6966 1.22966 58.5219 1.14221 58.3278C1.05477 58.1337 1.00647 57.9239 1 57.7111V2.57145C1.00647 2.35868 1.05477 2.14932 1.14221 1.95524C1.22966 1.76116 1.35455 1.58591 1.50964 1.4401C1.66474 1.2943 1.84704 1.18045 2.04614 1.10514C2.24525 1.02983 2.45728 0.994469 2.67004 1.00114H47.67C47.8836 0.993124 48.0966 1.02751 48.2969 1.10221C48.4971 1.17691 48.6808 1.29075 48.8369 1.43668C48.9931 1.58262 49.1187 1.75804 49.2068 1.9528C49.2949 2.14755 49.3435 2.35781 49.35 2.57145V57.7111C49.3435 57.9247 49.2949 58.135 49.2068 58.3298C49.1187 58.5245 48.9931 58.6999 48.8369 58.8459C48.6808 58.9918 48.4971 59.1056 48.2969 59.1803C48.0966 59.255 47.8836 59.2894 47.67 59.2814Z"
                fill="white"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17.7897 10.311L12.0996 17.0112L8.67969 13.6313"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M24.9609 14.4712H39.171"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17.7897 40.3711L12.0996 47.0713L8.67969 43.6914"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17.7897 25.3413L12.0996 32.041L8.67969 28.6611"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M20.2611 43.3012C20.0271 43.4314 19.827 43.6146 19.6768 43.8363C19.5267 44.0581 19.4307 44.3119 19.3967 44.5775C19.3626 44.8431 19.3915 45.1132 19.4808 45.3656C19.5701 45.6181 19.7176 45.8461 19.9111 46.0311L34.9111 60.3309C41.7511 66.4609 51.0911 66.021 57.3811 58.931C60.3811 55.561 62.5111 53.1609 59.8811 43.5009L56.111 31.9808C55.8727 31.1974 55.3665 30.523 54.681 30.0751C53.9955 29.6272 53.1742 29.4347 52.361 29.5311C51.878 29.6042 51.4168 29.7816 51.0094 30.0512C50.602 30.3207 50.2582 30.6762 50.0022 31.0922C49.7461 31.5082 49.5838 31.9747 49.5266 32.4599C49.4694 32.945 49.5188 33.4371 49.6711 33.9013L51.731 40.2108L49.0411 31.9911C48.8048 31.2085 48.3004 30.5338 47.6165 30.0858C46.9327 29.6378 46.113 29.4449 45.3011 29.5409C44.8172 29.6127 44.3547 29.7895 43.9461 30.0585C43.5376 30.3275 43.1926 30.6824 42.9355 31.0985C42.6784 31.5147 42.5153 31.9819 42.4575 32.4677C42.3997 32.9534 42.4487 33.4462 42.601 33.911L44.6811 40.2709L41.961 31.9808C41.7264 31.1971 41.2226 30.5219 40.5383 30.0736C39.854 29.6253 39.0332 29.4331 38.221 29.5311C37.7371 29.6029 37.2748 29.7792 36.8662 30.0482C36.4576 30.3173 36.1127 30.6726 35.8556 31.0888C35.5984 31.5049 35.4353 31.9721 35.3775 32.4579C35.3198 32.9437 35.3687 33.4364 35.5211 33.9013L37.6211 40.3212L32.0511 23.3212C31.8128 22.5377 31.3065 21.8628 30.6209 21.4149C29.9354 20.967 29.1143 20.7745 28.3011 20.871C27.818 20.9444 27.3566 21.122 26.9489 21.3915C26.5413 21.6609 26.1971 22.0158 25.9403 22.4315C25.6834 22.8472 25.52 23.3141 25.4614 23.7992C25.4028 24.2843 25.4505 24.7762 25.601 25.2411L33.1611 48.3412L27.6911 44.2211C25.0111 42.2311 22.5911 42.0312 20.2611 43.3012Z"
                fill="white"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
export const IconPec5 = () => {
    return (
        <svg
            width="69"
            height="67"
            viewBox="0 0 69 67"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="step-icon"
        >
            <path
                d="M46.22 19.5244H48.34C48.7597 19.5244 49.1754 19.6071 49.5631 19.7681C49.9508 19.929 50.3029 20.1646 50.5993 20.4619C50.8956 20.7592 51.1303 21.1123 51.2901 21.5005C51.4498 21.8887 51.5314 22.3044 51.53 22.7241V53.2842C51.5314 53.7039 51.4498 54.1196 51.2901 54.5078C51.1303 54.896 50.8956 55.2491 50.5993 55.5464C50.3029 55.8437 49.9508 56.0793 49.5631 56.2402C49.1754 56.4012 48.7597 56.4844 48.34 56.4844H4.18996C3.7702 56.4844 3.35462 56.4012 2.96693 56.2402C2.57925 56.0793 2.22715 55.8437 1.9308 55.5464C1.63445 55.2491 1.39973 54.896 1.24001 54.5078C1.08028 54.1196 0.9987 53.7039 1.00002 53.2842V22.7144C1.00002 21.8683 1.3361 21.0567 1.93434 20.4585C2.53258 19.8603 3.34392 19.5244 4.18996 19.5244H46.19H46.22Z"
                fill="white"
                stroke="#2B2B2B"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M1 50.0947H51.53"
                stroke="#2B2B2B"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M20.9883 56.7646V65.3745"
                stroke="#2B2B2B"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M31.2578 56.7646V65.3745"
                stroke="#2B2B2B"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M15.9883 65.374H36.2583"
                stroke="#2B2B2B"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M56.8694 20.8252L53.3294 28.605C51.7894 32.005 44.4994 32.005 37.0594 28.605C29.6194 25.205 24.8394 19.7252 26.3894 16.3252L29.9095 8.5752"
                fill="#FFE22E"
            />
            <path
                d="M56.8694 20.8252L53.3294 28.605C51.7894 32.005 44.4994 32.005 37.0594 28.605C29.6194 25.205 24.8394 19.7252 26.3894 16.3252L29.9095 8.5752"
                stroke="black"
                strokeWidth="1.87"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M41.1088 19.7749L22.2188 0.93457L48.8387 2.59473L67.7388 21.4448L41.1088 19.7749Z"
                fill="#FFE22E"
                stroke="black"
                strokeWidth="1.87"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M50.2891 9.5752L61.629 20.8652V36.7251"
                stroke="black"
                strokeWidth="1.87"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
